import customTheme from '@/constants/theme.custom';
import useIsMobile from '@/hooks/use-is-mobile';
import { Image } from '@chakra-ui/react';
import { Box, Text } from '@cmpsr/components';

const SecurePayments = () => {
  const isMobile = useIsMobile();
  return (
    <Box display="flex" alignItems="center" gap={2} justifyContent="flex-end">
      {!isMobile && (
        <Text fontFamily={customTheme.typography.fonts.inter} fontSize="16px">
          Secure Payments
        </Text>
      )}
      <Image src="/images/icons/lock.svg" alt="Lock icon in the locked position" />
    </Box>
  );
};

export default SecurePayments;
